export default {
    top_menu: [
        {name:'Hlavní věc',    id:0},
        {name:'Show-byznysu', id:1},
        {name:'Vaření',  id:2},
        {name:'Politika',   id:3},
        {name:'+18',  id:4},
        {name:'Společnost',   id:5},
        {name:'Zdraví',   id:6},
    ],
    read_other: 'Přečtěte si více',
    read_more:  'Více informací',
    not_found:  'Nic nalezeno',
    read_also:  'Přečtěte si také',
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». Všechna práva vyhrazena.',
    subscribe: 'Popsat',

    thank_order: 'DÍKY ZA VAŠI OBJEDNÁVKU',
    specialist_contact: 'Náš specialista vás bude brzy kontaktovat, počkejte na naše zavolání.',
    attention: 'Slevy od partnerů:',
    hurry: 'Pospěšte si, doba aktivace slevy je omezená! Na výběr jednoho z těchto unikátních produktů máte jen <span id="time" class="time">30:00</span> minut:',

    hour_ago1: "Před hodinou",
    hour_ago2: "před hodinami",
    hour_ago3: "před hodinami",
    new_publications: "Nové publikace",
    read: "Číst",
    today_at: "Dnes v",
    author_names: ['Petr Tenkrát','Leoš Janáček','Lucie Vondráčková'],
    main_news: "Hlavní novinky",
    leave_already: "Už odcházíš? Počkejte, aktualizovali jsme pro vás novinky",
    already_shared: "již sdílené"

}